module.exports = __webpack_public_path__ + "img/sdg_en_(5).5fea4720.png";